import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { ParameterMaintenanceConstant } from "presentation/constant/Parameter/ParameterMaintenanceConstant";
import { useParameterMaintenanceVM } from "presentation/hook/Parameter/useParameterMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useParameterMaintenanceTracked } from "presentation/store/Parameter/ParameterMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { IFieldValue, NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHCheckbox, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const ParameterCodeEditPanel = () => {
    const [paramMainState] = useParameterMaintenanceTracked();
    const paramMainVM = useParameterMaintenanceVM();
    const { masterState } = paramMainState;
    const [isLoading, setIsLoading] = useState(false);
    const { updateParamEntity } = masterState;
    const PARAM_MAIN_CONSTANT = ParameterMaintenanceConstant;
    const messageBarVM = useMessageBarVM();
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate } = anainfoState;

    const handleCancelClick = useCallback(() => {
        paramMainVM.onCancel();
    }, [paramMainVM])

    const handleSaveClick = useCallback(async () => {
        setIsLoading(true);
        await paramMainVM.onSaveHdr(updateParamEntity).then(async (data) => {
            if (data as ResponseEntity && !data.success) {
                setIsLoading(false);
                messageBarVM.showError('Save Data Failed.');
                return;
            }
            await paramMainVM.searchParameter().then(() => {
                paramMainVM.onCancel();
                messageBarVM.showSuccess("Save Successfully.");
                setIsLoading(false);
            }).catch((error) => {
                setIsLoading(false);
            });
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Save Data Failed.');
        });
    }, [paramMainVM, updateParamEntity, messageBarVM])

    const handleTextAreaChange = useCallback((fieldName: string, fieldValue: IFieldValue) => {
        paramMainVM.onFieldChange(fieldName, fieldValue);
    }, [paramMainVM])

    const memoParamCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "480px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={updateParamEntity?.parameterCode ?? ''}
                fieldValue={updateParamEntity?.parameterCode ?? ''}
                allValues={updateParamEntity?.parameterCode ?? ''}
                fieldLabel={PARAM_MAIN_CONSTANT.PARAMETER_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'parameterCode'}
                isShowMissingError={false}
                maxLength={100}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    paramMainVM.onFieldChange(fieldKey, fieldValue, fFullValue)
                } />
        </div>
        , [updateParamEntity?.parameterCode, PARAM_MAIN_CONSTANT.PARAMETER_CODE, paramMainVM])

    const memoParamDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "480px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={!allowUpdate}
                isShowOptional={true}
                readOnlyValue={updateParamEntity?.parameterDesc ?? ''}
                fieldValue={updateParamEntity?.parameterDesc ?? ''}
                allValues={updateParamEntity?.parameterDesc ?? ''}
                fieldLabel={PARAM_MAIN_CONSTANT.PARAMETER_DESC}
                isSaveClicked={false}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'parameterDesc'}
                isShowMissingError={false}
                maxLength={300}
                requiredFieldList={[]}
                onFieldChange={handleTextAreaChange} />
        </div>
        , [allowUpdate, PARAM_MAIN_CONSTANT.PARAMETER_DESC, handleTextAreaChange, updateParamEntity?.parameterDesc])

    const memoActiveInd = useMemo(() =>
        <>
            <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>

                <NbisCommonField
                    fieldKey={"activeInd"}
                    requiredFieldList={[]}
                    fieldLabel={PARAM_MAIN_CONSTANT.ACTIVE_IND}
                    fieldType={FieldType.TEXT}
                    isReadOnly={true}
                    onFieldChange={() => { }} />
                <HPHCheckbox
                    label={""}
                    checked={updateParamEntity?.activeInd === 'Y'}
                    disabled={!allowUpdate}
                    onChange={(e) => paramMainVM.onCheckboxChange(e.checked, "activeInd")}
                />
            </div>
        </>
        , [allowUpdate, PARAM_MAIN_CONSTANT.ACTIVE_IND, paramMainVM, updateParamEntity?.activeInd])

    return <div className='side-form-content-wrapper'>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>{allowUpdate ? 'Update Parameter Code Information' : 'Parameter Code Information'}</SidebarTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <CriteriaItemContainer>
                        {memoParamCode}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoParamDesc}
                    </CriteriaItemContainer>

                    <CriteriaItemContainer>
                        {memoActiveInd}
                    </CriteriaItemContainer>
                </div>
            </div>
        </div>
        <div className='im-charge-data-search-criteria-buttons'>
            {
                <>
                    <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={() => handleCancelClick()} />
                    {allowUpdate && <HPHButton label={'Update'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />}
                </>
            }
        </div>
    </div>
}
